import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";

const FIELDS = [
  ["name", "Name *", "sm:col-span-2"], ["street", "Straße & Nr."], ["contact_person", "Ansprechpartner"],
  ["zip", "PLZ"], ["city", "Ort"], ["phone", "Telefon"], ["fax", "Telefax"], ["email", "E-Mail"], ["website", "Webseite"],
];
const EMPTY = { name: "", street: "", zip: "", city: "", phone: "", fax: "", email: "", website: "", contact_person: "", opening_hours: "", notes: "", prices: {} };

export default function YardFormDialog({ yard, grades, onClose, onSaved }) {
  const api = useApi();
  const [form, setForm] = useState({ ...EMPTY, ...(yard || {}) });
  const [prices, setPrices] = useState(Object.fromEntries(Object.entries(yard?.prices || {}).map(([k, v]) => [k, String(v).replace(".", ",")])));
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    const p = {};
    for (const [k, v] of Object.entries(prices)) {
      const n = parseFloat(String(v).replace(",", "."));
      if (!isNaN(n) && n > 0) p[k] = n;
    }
    const { id, created_at, prices_updated_at, ...rest } = form;
    try {
      if (yard) await api.put(`/yards/${yard.id}`, { ...rest, prices: p });
      else await api.post("/yards", { ...rest, prices: p });
      toast.success("Wertstoffhof gespeichert");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto border-slate-200 bg-white" data-testid="dialog-yard-form">
        <DialogHeader><DialogTitle>{yard ? "Wertstoffhof bearbeiten" : "Neuer Wertstoffhof"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {FIELDS.map(([k, l, cls]) => (
            <div key={k} className={cls}><Label>{l}</Label><Input value={form[k]} onChange={set(k)} data-testid={`input-yard-${k}`} /></div>
          ))}
          <div className="sm:col-span-2"><Label>Öffnungszeiten</Label><Textarea rows={3} value={form.opening_hours} onChange={set("opening_hours")} data-testid="input-yard-opening_hours" /></div>
          <div className="sm:col-span-2"><Label>Notizen</Label><Textarea rows={2} value={form.notes} onChange={set("notes")} data-testid="input-yard-notes" /></div>
        </div>
        <div className="mt-2">
          <h4 className="mb-2 text-sm font-semibold">Ankaufspreise (€/kg)</h4>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {grades.map((g) => (
              <div key={g.key} className="flex items-center gap-2">
                <span className="flex-1 truncate text-sm text-slate-600">{g.name}</span>
                <Input className="w-28 num" inputMode="decimal" placeholder="–" value={prices[g.key] ?? ""} onChange={(e) => setPrices({ ...prices, [g.key]: e.target.value })} data-testid={`input-yard-price-${g.key}`} />
              </div>
            ))}
          </div>
        </div>
        <DialogFooter><Button onClick={save} data-testid="btn-save-yard">Speichern</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
